module.exports = __webpack_public_path__ + "../resources/images/SkyCode_6-9d74fa2721b333c3732ab414fa959e90.svg";